import { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { useParams } from 'react-router-dom'
import { Plus } from 'lucide-react'
import { Button } from 'components/ui/button'

import queryClient from 'config/tanstackQuery'

import { Input } from 'components/form/input'
import useTemNewStore from 'store/client/temNewStore'

export default function SizesHome({ idx, setdepartmantIDD, setifinch,ifinch }) {
  const { orderNo } = useParams()
  const { values, setFieldValue } = useFormikContext()

  const cacheData = queryClient.getQueryData(['/list', 'sizeGroup'])
  const { specialValue } = useTemNewStore();

  const initialSizeData = {
    name: '',
    amount: '',
    amountWithDefect: '',
    cn: '',
    sCode: '',
    isCustomInch: true,
    inches: '',
    usa: '',
    mexico: '',
    'br-brasil': '',
    europe: '',
    cm: ''
  }

  const getSizeDisplay = (item, findSizeData) => {
    // Eğer cm veya inches varsa, bu bir tekstil ürünü
    if (item.cm || item.inches) {
      setifinch(true)
      return item.cm || item.inches;
    }
    
    // Eğer europe, usa, mexico, br-brasil varsa, bu bir giyim ürünü
    if (item.europe || item.usa || item.mexico || item['br-brasil']) {
      const isCocuk = findSizeData?.name?.includes('ÇOCUK');
      const isBebek = findSizeData?.name?.includes('BEBEK');
      setifinch(false)
      if (isCocuk || isBebek) {
        return item.size?.split(' ')[0] || item.europe;
      }
      
      return item.europe || item.usa || item.mexico || item['br-brasil'];
    }

    // Diğer durumlar için varsayılan değer
    return item.size || item.scode || '';
  };

  const addCustomInch = () => {
    const currentSizes = [...values.washingLabel[idx].sizes];
    currentSizes.push({
      name: '',
      amount: '',
      amountWithDefect: '',
      cn: '',
      sCode: '',
      isCustomInch: true
      
    });
    setFieldValue(`washingLabel[${idx}].sizes`, currentSizes);
  };

  const handleSizeChange = (index, field, value) => {
    const newSizes = [...values.washingLabel[idx].sizes]
    newSizes[index] = {
      ...newSizes[index],
      [field]: value,
      // Eğer inches değiştiyse ve diğer alanlar boşsa, onları da güncelle
      ...(field === 'inches' && !newSizes[index].usa && !newSizes[index].mexico && !newSizes[index]['br-brasil'] && {
        usa: value,
        mexico: value,
        'br-brasil': value
        
      })
    }
    setFieldValue(`washingLabel[${idx}].sizes`, newSizes)
  }

  useEffect(() => {
    const updateSizes = () => {
      if (!cacheData) return;
      const findSizeData = cacheData.find((item) => item.id === values.sizeGroup);
      if (!findSizeData) return;
      setdepartmantIDD(findSizeData.id)

      const newSizes = findSizeData.sizes.map((item, idx2) => {
        const sizeDisplay = getSizeDisplay(item, findSizeData);
        console.log("getSizeDisplay sonucu:", sizeDisplay);
        console.log("item:", item);
        console.log("findSizeData:", findSizeData);
        
        const base = {
          name: item.scode,
          amount: '',
          amountWithDefect: '',
          cn: item.cnupperwoman || item.cm || '',
          sCode: item.scode || '',
          uid: item.uid,
        };

        const dynamicSizeFields = Object.keys(item).reduce((acc, key) => {
          if (
            ['scode', 'amount', 'amountWithDefect', 'name'].includes(key) ||
            typeof item[key] !== 'string'
          ) {
            return acc; // sabit alanları atla
          }
      
          // Örneğin "cn", "cm", "usa", "europe", "br-brasil", vs.
          acc[key] = item[key] || '';
          return acc;
        }, {});
      
        return {
          ...base,
          ...dynamicSizeFields,
        };
      });
      
      setFieldValue(`washingLabel[${idx}].sizes`, newSizes);
    };

    const updateSizes2 = () => {
      if (!cacheData) return;

      const findSizeData = cacheData.find((item) => item.id === values.sizeGroup);
      if (!findSizeData) return;
      console.log("findSizeDataHomeeee",findSizeData)
      setdepartmantIDD(findSizeData.id)

      const newSizes = findSizeData.sizes.map((item, idx2) => {
        const sizeDisplay = getSizeDisplay(item, findSizeData);
        console.log("getSizeDisplay sonucu:", sizeDisplay);
        console.log("item:", item);
        console.log("findSizeData:", findSizeData);
        const base = {
          name: item.scode,
          amount: values.washingLabel[idx]?.sizes[idx2]?.amount || '',
          amountWithDefect: values.washingLabel[idx]?.sizes[idx2]?.amountWithDefect || '',
          sCode: item.scode || '',
          uid: item.uid,
        };
      
        // Ölçü birimlerini dinamik olarak bul
        const dynamicSizeFields = Object.keys(item).reduce((acc, key) => {
          if (
            ['scode', 'amount', 'amountWithDefect', 'name'].includes(key) ||
            typeof item[key] !== 'string'
          ) {
            return acc; // sabit alanları atla
          }
      
          // Örneğin "cn", "cm", "usa", "europe", "br-brasil", vs.
          acc[key] = item[key] || '';
          return acc;
        }, {});
      
        return {
          ...base,
          ...dynamicSizeFields,
        };
      });
      
      
      setFieldValue(`washingLabel[${idx}].sizes`, newSizes);
    };

    if (!orderNo || (orderNo && values.washingLabel[idx]?.sizes?.length === 0)) {

      updateSizes();
    } else {

      updateSizes2();
    }
  }, [cacheData, orderNo, specialValue, values.sizeGroup, idx, setFieldValue]);

  const totalAmount = values.washingLabel[idx].sizes?.reduce((acc, curr) => {
    if (curr.amount) return acc + parseInt(curr.amount)
    return acc
  }, 0)

  const totalAmountWithDefect = values.washingLabel[idx].sizes?.reduce((acc, curr) => {
    const amount = curr.amountWithDefect
    if (amount.length > 1) return acc + parseInt(amount)
    return acc
  }, 0)

  return (
    <div className="rounded border border-dashed p-2">
      <div className="mb-2 grid grid-cols-4 gap-x-5 text-sm font-medium text-simsek">
        <p>Beden</p>
        <p>Adet</p>
        <p>%</p>
        <p>Fireli Adet</p>
      </div>
      <div className="space-y-1">
        {values.washingLabel[idx].sizes.length < 1 ? (
          <div className="bg-rose-400 rounded p-2 text-center my-4">
            <p className="text-white text-sm">Lütfen beden tablosu seçiniz!</p>
          </div>
        ) : (
          values.washingLabel[idx].sizes.map((size, index) => {
            const amount = size?.amount
            const percent =
              (amount *
                values.washingLabel[idx].sizeDefectivePercent) /
                100 || 0
            const wastageQuantity = String(parseInt(amount) + parseInt(percent))
            return (
              <div className="grid grid-cols-4 gap-x-5" key={index}>
                <Input
                  name={`washingLabel[${idx}].sizes[${index}].name`}
                  value={size.name}
                  disabled={!size.isCustomInch}
                  autoComplete="off"
                />
                <Input
                  name={`washingLabel[${idx}].sizes[${index}].amount`}
                  value={size.amount}
                  onChange={(e) => handleSizeChange(index, 'amount', e.target.value)}
                />

                <Input name={`washingLabel[${idx}].sizeDefectivePercent`} autoComplete="off"
                  type="number"
                  min={0}
                  max={20}
                  step={1}
                  inputMode="numeric"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    const digitsOnly = String(e.target.value).replace(/\D/g, '')
                    if (digitsOnly === '') {
                      setFieldValue(`washingLabel[${idx}].sizeDefectivePercent`, '')
                      return
                    }
                    let n = parseInt(digitsOnly, 10)
                    if (Number.isNaN(n)) return
                    n = Math.min(20, Math.max(0, n))
                    setFieldValue(`washingLabel[${idx}].sizeDefectivePercent`, n)
                  }}
                />



                <Input
                  name={`washingLabel[${idx}].sizes[${index}].amountWithDefect`}
                  autoComplete="off"
                  value={
                    values.washingLabel[idx].sizes[index].amount.length === 0
                      ? ' '
                      : wastageQuantity
                  } 
                  disabled
                />
              </div>
            )
          })
        )}
        {values.washingLabel[idx].sizes.length > 0 && (
          <>
            <div className="grid grid-cols-4 gap-x-10">
              <p></p>
              <p className="text-sm font-semibold text-center">{totalAmount}</p>
              <p></p>
              <p className="text-sm font-semibold text-center">{totalAmountWithDefect}</p>
            </div>
            {ifinch && (
              <div className="mt-2">
                <Button
                  type="button"
                  variant="outline"
                  size="sm"
                  onClick={addCustomInch}
                  className="w-full"
                >
                  <Plus className="w-4 h-4 mr-2" />
                  Özel İnç Ekle
                </Button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}
